export const SEND_CONTACT_FORM_SUCCESS = 'SEND_CONTACT_FORM_SUCCESS'
export const SEND_CONTACT_FORM_FAILED = 'SEND_CONTACT_FORM_FAILED'
export const SEND_CONTACT_FORM_START = 'SEND_CONTACT_FORM_START'

export const sendContactFormSuccess = data => ({
	type: SEND_CONTACT_FORM_SUCCESS,
	data,
})

export const sendContactFormFailed = () => ({
	type: SEND_CONTACT_FORM_FAILED,
})

export const sendContactFormStart = data => ({
	type: SEND_CONTACT_FORM_START,
	data,
})

export const sendContactForm = data => (dispatch, getState, {submitContactForm}) => {
	dispatch(sendContactFormStart(data))
	return submitContactForm(data)
		.then(data => {
			dispatch(sendContactFormSuccess(data))
			return data
		})
		.catch(() => {
			dispatch(sendContactFormFailed())
			return Promise.reject()
		})
}



// WEBPACK FOOTER //
// ./src/actions/sendContactForm.js